var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell',{staticClass:"activity"},[_c('div',{staticClass:"activity-text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"activity-date"},[_vm._v(_vm._s(_vm._f("fromNow")(_vm.action.date)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }